<template>
  <div class="service-card" title="Service öffnen">
    <router-link :to="`/services/${service.id}`">
      <Card padding="0px">
        <div class="service-card__content">
          <div class="service-card__content--top">
            <div>
              <h3>{{ service.title }}</h3>
              <p>{{ service.authority }}</p>
            </div>
            <Icon :icon="service.iconName" color="detailed"/>
          </div>
          <div class="service-card__content--bottom">
            <div class="service-card__content--bottom__left">
              <Icon icon="clock"/>
              <span>{{ service.duration }} min</span>
            </div>
            <div class="service-card__content--bottom__right">
              <Icon :icon="onlineIcon"/>
              <span>{{ onlineService }}</span>
            </div>
          </div>
        </div>
      </Card>
    </router-link>
  </div>
</template>

<script>
import Card from '../Card/Card';
import Icon from '../Icon/Icon';

export default {
  name: 'ServiceCard',
  components: {
    Card,
    Icon,
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  computed: {
    onlineIcon() {
      return (this.service.online ? 'computer' : 'noComputer');
    },
    onlineService() {
      return (this.service.online ? 'ja' : 'nein');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./ServiceCard.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/ServiceCard/ServiceCard.vue